/**
 * @author caijianjia
 * @date 2020/3/29 2:32 下午
 */

export const coinTableHead = [{
  prop: 'name',
  label: '元素类型',
  width: '180'
}, {
  prop: 'number',
  label: '数量'
}, {
  prop: 'amount',
  label: '扣除金币'
}]

// export const coinTableData = [{
//   date: '2016-05-02',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1518 弄'
// }, {
//   date: '2016-05-04',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1517 弄'
// }, {
//   date: '2016-05-01',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1519 弄'
// }, {
//   date: '2016-05-03',
//   name: '王小虎',
//   address: '上海市普陀区金沙江路 1516 弄'
// }]
